<template>
  <VLayout
    v-update-main-height
    column
    justify-end
    fill-height
  >
    <VFlex
      xs12
    >
      <VTabs
        centered
        color="grey lighten-4"
        icons-and-text
        slider-color="blue"
        @change="onTabChanged"
      >
        <VTab href="#tab-1">
          Interest ({{ getTotalInterests("tab-1") }})
          <VIcon>favorite</VIcon>
        </VTab>
        <VTabItem
          v-for="i in 1"
          :key="i"
          :value="'tab-' + i"
        >
          <VCard
            flat
            :height="window.height"
            style="overflow: auto"
          >
            <ListViewPage
              :get-gql-query="getGqlQuery"
              :get-current-table-data="getCurrentTableData"
              :get-query-variables="getQueryVariables"
              :update-context-variable="updateContextVariable"
              :fetching-more="isFetchingMore"
              :get-loading-status="getLoadingStatus"
              :set-loading-status="setLoadingStatus"
              :get-status-message="getStatusMessage"
              :set-status-message="setStatusMessage"
              :parse-get-data="parseData"
              :clear-data="clearData"
            >
              <template slot="table">
                <InterestTable
                  @fetchingMore="onFetchingMore"
                />
              </template>
            </ListViewPage>
          </VCard>
        </VTabItem>
      </VTabs>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { interestMapActions } from '@/store/modules/interest'
import ListViewPage from '@/pages/ListViewPage'
import InterestTable from '@/components/InterestTable'
import { LIST_INTERESTS } from '@/backend/graphql/interestGQL'
export default {
  name: 'InterestsPage',
  components: {
    InterestTable, ListViewPage
  },
  directives: {
    'update-main-height': {
      inserted: function (el, binding, vnode) {
        const self = vnode.context
        self.window.initialHeight = el.parentElement.parentElement.clientHeight
        self.window.height = self.window.initialHeight - 93
      }
    }
  },
  data: function () {
    return {
      currentTab: 'tab-1',
      getGqlQuery: LIST_INTERESTS,
      limit: 50,
      offset: 0,
      orderBy: 'name',
      isDelete: 0,
      isFetchingMore: false,
      window: {
        width: 0,
        height: 0,
        initialHeight: 0
      }
    }
  },
  computed: {
    ...mapGetters({ allInterests: 'interest/getAllInterests' })
  },
  created () {
    this.setStatusMessage('Loading Interests. Please wait...')
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.setEditMenuItems({ val: [] })
    this.setMessageDrawerVisibility({ val: false })
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(Object.assign(interestMapActions, {
      setEditMenuItems: 'toolBar/setEditMenuItems',
      setMessageDrawerVisibility: 'messageDrawer/setVisibility'
    })),
    getItems (data) { return data.listInterests.results },
    getCurrentTableData () { return this.allInterests },
    getTotalItemsCount (data) { return data.listInterests.totalCount },
    getLoadingStatus () { return this.$store.getters['interest/getLoadingStatus'] },
    setLoadingStatus (val) { this.$store.dispatch('interest/setLoadingStatus', { val }) },
    getStatusMessage () { return this.$store.getters['interest/getLoadingText'] },
    setStatusMessage (message) { this.$store.dispatch('interest/setStatusMessage', { message }) },
    parseData (data) {
      if (this.allInterests.length === 0) {
        this.initInterests({
          newInterests: this.getItems(data),
          totalCount: this.getTotalItemsCount(data),
          isFullArraySize: false
        })
      } else {
        this.appendInterests({
          newInterests: this.getItems(data),
          startIndex: this.getQueryVariables().offset
        })
        this.isFetchingMore = false
      }
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        isDelete: this.isDelete
      }
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    clearData () { this.clearInterests() },
    onFetchingMore () {
      if (!this.isFetchingMore) {
        this.isFetchingMore = true
      }
    },
    getTotalInterests (value) {
      if (value === this.currentTab) {
        return this.$store.getters['interest/getTotalCount']
      } else {
        return '?'
      }
    },
    onTabChanged (value) {
      this.currentTab = value
    },
    handleResize () {
      this.window.width = window.innerWidth
    }
  }
}
</script>

<style scoped>

</style>
